module.exports = __webpack_public_path__ + "static/media/60.9c519305.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/60.png
// module id = 634
// module chunks = 0